import React from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  useTheme,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import MeetingLogo from "../assets/Meet-ing-logo.jpg";

export default function AuthHeader() {
  const location = useLocation();
  const theme = useTheme();

  const isLoginPage = location.pathname === '/login';
  const isRegisterPage = location.pathname === '/register';

  return (
    <Box>
      <AppBar 
        position="fixed" 
        color="default" 
        elevation={0} 
        sx={{ 
          height: "73px", 
          zIndex: theme.zIndex.appBar,
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
          backdropFilter: 'blur(8px)',
          transition: 'box-shadow 0.2s ease, backdrop-filter 0.2s ease',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Toolbar sx={{ height: "100%", px: 2, py: 3 }}>
          {/* Left Section - Logo */}
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <Box 
              component={Link}
              to="/"
              sx={{ display: "flex", alignItems: "center", textDecoration: 'none' }}
            >
              <Box component="img" src={MeetingLogo} alt="Meeting logo" sx={{ width: 128, height: 47 }} />
            </Box>
          </Box>

          {/* Right Section - Auth Buttons */}
          <Box sx={{ display: "flex", gap: 2 }}>
            {!isLoginPage && (
              <Button 
                component={Link} 
                to="/login" 
                variant="outlined"
                sx={{
                  borderRadius: "3px",
                  textTransform: "none",
                  fontFamily: theme.typography.fontFamily,
                  fontWeight: 500,
                  fontSize: "14px",
                  px: 3,
                  py: 1,
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                Login
              </Button>
            )}
            
            {!isRegisterPage && (
              <Button 
                component={Link} 
                to="/register" 
                variant="contained"
                sx={{
                  borderRadius: "3px",
                  backgroundColor: theme.palette.primary.main,
                  boxShadow: theme.shadows[3],
                  textTransform: "none",
                  fontFamily: theme.typography.fontFamily,
                  fontWeight: 500,
                  fontSize: "14px",
                  px: 3,
                  py: 1,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                    boxShadow: theme.shadows[6],
                  },
                }}
              >
                Register
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      
      {/* Spacer to push content below fixed header */}
      <Box sx={{ height: "73px" }} />
    </Box>
  );
} 